// extracted by mini-css-extract-plugin
module.exports = {"betaTag":"betaTag_betaTag__1h7Xh"};